// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Sj-z","zenCrossSiteLabel":"Tj-z","vrsnlCrossSiteLabel":"Uj-z"};